import type { TemplateContent, ContentNode } from "@/types/template";
import type { JSONContent } from "@tiptap/react";

function textToParagraphs(markdown: string): JSONContent[] {
  return markdown
    .split("\n")
    .map((line) =>
      line.trim()
        ? { content: [{ text: line, type: "text" }], type: "paragraph" }
        : { type: "paragraph" },
    );
}

export function contentToNodes(content: ContentNode[]): JSONContent[] {
  const nodes: JSONContent[] = [];
  let currentSectionId: string | undefined;

  for (const node of content) {
    switch (node.type) {
      case "section": {
        currentSectionId = node.id;
        nodes.push({
          attrs: { required: node.required, sectionId: node.id },
          content: [{ text: node.title, type: "text" }],
          type: "section",
        });
        break;
      }
      case "heading": {
        nodes.push({
          attrs: { level: node.level },
          content: [{ text: node.text, type: "text" }],
          type: "heading",
        });
        break;
      }
      case "text": {
        nodes.push(...textToParagraphs(node.markdown));
        break;
      }
      case "field": {
        nodes.push({
          attrs: { fieldDef: JSON.stringify(node.field), sectionId: currentSectionId },
          type: "fieldNode",
        });
        break;
      }
      case "scoregroup": {
        nodes.push({ attrs: { id: node.id }, type: "scoregroupNode" });
        break;
      }
    }
  }

  return nodes;
}

export function templateToDocument(content: TemplateContent): JSONContent {
  return { content: contentToNodes(content.content), type: "doc" };
}
